import { render, staticRenderFns } from "./ProformaNo.vue?vue&type=template&id=158cabad&"
import script from "./ProformaNo.vue?vue&type=script&lang=js&"
export * from "./ProformaNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports